module.exports = __webpack_public_path__ + "assets/media/1.23ef1a5a.wav";